import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FaTimes } from 'react-icons/fa';
import PropTypes from 'prop-types';
import  { registerLocale } from 'react-datepicker';
import pt from 'date-fns/locale/pt-BR';

import Button from '~/Components/Button';
import Modal from '~/Components/Modal';

import { Creators as FinancialActions } from '~/redux/ducks/financial';

import {
  Row,
  RowFooter,
  ButtonCloseModal,
  FormGroup,
} from './styles';
import {Select} from "~/Pages/Financial/Pages/Provider/styles";

registerLocale('pt-BR', pt);

class ModalUpdateInvoiceStatus extends Component {

  getFormIsValid = () => {
    const { modalInvoiceStatusData } = this.props;
    return !!modalInvoiceStatusData.documentStatus && !!modalInvoiceStatusData.documentStatus.uuid;
  }

  componentDidMount() {
    const { financialInvoiceStatusesRequest } = this.props
    financialInvoiceStatusesRequest()
  }

  render() {
    const { setModalInvoiceStatusData, modalInvoiceStatusData, statuses, financialInvoiceStatusSave } = this.props;
    return (
      <Modal width={700} scroll={false}>
        <Row>
          <h1>{`Alterar Status - ${modalInvoiceStatusData.provider.name}`}</h1>
          <ButtonCloseModal
            type="button"
            onClick={() => setModalInvoiceStatusData(null)}
          >
            <FaTimes size={30} />
          </ButtonCloseModal>
        </Row>
        <Row>
          <FormGroup>
            <label>
              <b>Ano:</b>
              {modalInvoiceStatusData.year}
            </label>
          </FormGroup>
          <FormGroup>
            <label>
              <b>Mês:</b>
              {modalInvoiceStatusData.monthLabel}
            </label>
          </FormGroup>
          <FormGroup>
            <label>
              <b>Parceiro:</b>
              {modalInvoiceStatusData.partner.name}
            </label>
          </FormGroup>
        </Row>
        <Row>
          <Select
            value={modalInvoiceStatusData.documentStatus}
            onChange={(documentStatus) => {
              setModalInvoiceStatusData({
                ...modalInvoiceStatusData,
                documentStatus,
              });
            }}
            getOptionLabel={(option) => option.label}
            getOptionValue={(option) => option.name}
            options={statuses.filter((status) => ['LATE_PAYMENT', 'PAID', 'WITHOUT_INVOICE'].includes(status.name))}
            styles={{
              option: (provided, state) => ({
                ...provided,
                backgroundColor: state.isFocused ? '#f0f0f0' : 'white', // Light gray on focus, white otherwise
                color: 'black', // Text color
              }),
              control: (provided) => ({
                ...provided,
                borderColor: '#ccc', // Customize border color
              }),
            }}
          />
        </Row>
        <RowFooter>
          <Button
            disabled={!this.getFormIsValid()}
            title="Confirmar"
            onClick={() => financialInvoiceStatusSave(modalInvoiceStatusData.uuid, modalInvoiceStatusData.documentStatus.uuid )}
          />
        </RowFooter>
      </Modal>
    );
  }
}

ModalUpdateInvoiceStatus.defaultProps = {
  modalInvoiceStatusData: null,
};

ModalUpdateInvoiceStatus.propTypes = {
  modalInvoiceStatusData: PropTypes.shape(),
  setModalInvoiceStatusData: PropTypes.func.isRequired,
  financialInvoiceSave: PropTypes.func.isRequired,
  financialInvoiceStatusesRequest: PropTypes.func.isRequired,
  financialInvoiceStatusSave: PropTypes.func.isRequired,
  statuses: PropTypes.arrayOf(PropTypes.shape()).isRequired
};

const mapStateToProps = state => ({
  modalInvoiceStatusData: state.financial.modalInvoiceStatusData,
  statuses: state.financial.statuses
});

const mapDispatchToProps = dispatch => bindActionCreators(
  {
    setModalInvoiceStatusData: FinancialActions.setModalInvoiceStatusData,
    financialInvoiceSave: FinancialActions.financialInvoiceSave,
    financialInvoiceStatusesRequest: FinancialActions.financialInvoiceStatusesRequest,
    financialInvoiceStatusSave: FinancialActions.financialInvoiceStatusSave
  },
  dispatch,
);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ModalUpdateInvoiceStatus);
